export class MyContainerSharedMetadataModel {

    // table on 3.step
    // if item si checked to be shown in device list on step 3 via the Artikelnummer hinzufügen modal dialog
    public addToProductOrderList: boolean;

    // tables on 5.step
    // // if the item is listed into printSmart supply list ( applicable on devices and its supplies - not to warranties )
    // // if true, then it will be displayed on smart devices supply order list on 6. page
    // // it allowed user to specify if the supplies for mpsDevice will be ordered or not, but by new spec, the user has no choice, so the variable is usels
    // public addToRequestedPrintSmartDeviceSupplyOrderList: boolean;

    // if the item is listed into not-printSmart supply list on Kaufen tab ( applicable on devices and its supplies - not to  warranties )
    public addToNoCategorised5stepGeneralSupplyOrderList: boolean;

    // used for categories on 5.step modal-dialog "Verbrauchsmaterial hinzufügen" (Kaufen tab)
    // and indicates if the category is opened
    public isSupplyCategoryExpanded: boolean;

    public generalSupplyTableEditableRowIndex: number;
    public printSmartSupplyTableEditableRowIndex: number;


    constructor( addToProductOrderList = false,
                 // addToSmartDeviceSupplyOrderList = false,
                 addToNoCategorised5stepGeneralSupplyOrderList = false,
                 isCategoryExpanded = false) {

        this.addToProductOrderList = addToProductOrderList;
        // this.addToRequestedPrintSmartDeviceSupplyOrderList = addToSmartDeviceSupplyOrderList;
        this.addToNoCategorised5stepGeneralSupplyOrderList = addToNoCategorised5stepGeneralSupplyOrderList;
        this.isSupplyCategoryExpanded = isCategoryExpanded;

    }
}


